module.exports = __webpack_public_path__ + "static/05-b9b1fc8ff6a17498e1436ed653764b58.jpg";